module.exports = __webpack_public_path__ + "static/media/pg_clipboard_highlight.2bb6ea72.svg";